import gql from 'graphql-tag'

import { clickAndCollect } from './fragments'

export default gql`
query getCCRoute {
	cashAssist {
		getCCRoute {
			...clickAndCollect
		}
	}
}
${clickAndCollect}
`
